import { create } from 'zustand';
import type { AuthSession, AuthUser } from '@/types/auth';

/**
 * `bootstrapping` — first load, a stored refresh token is being exchanged; render nothing yet.
 * `authenticated` — access token in memory.
 * `anonymous`     — no session; protected routes redirect to /login.
 */
export type AuthStatus = 'bootstrapping' | 'authenticated' | 'anonymous';

interface AuthState {
  status: AuthStatus;
  user: AuthUser | null;
  /** In memory only — never persisted. */
  accessToken: string | null;
  setSession: (session: Pick<AuthSession, 'accessToken' | 'user'>) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()((set) => ({
  status: 'bootstrapping',
  user: null,
  accessToken: null,
  setSession: ({ accessToken, user }) => set({ status: 'authenticated', accessToken, user }),
  clear: () => set({ status: 'anonymous', accessToken: null, user: null }),
}));
